import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateEventAccountMutationVariables = Types.Exact<{
  input: Types.CreateEventAccountInput;
}>;


export type CreateEventAccountMutation = { __typename?: 'Mutation', createEventAccount: { __typename?: 'EventAccount', id: string, name?: string | null, description?: string | null, email?: string | null } };


export const CreateEventAccountDocument = gql`
    mutation CreateEventAccount($input: CreateEventAccountInput!) {
  createEventAccount(input: $input) {
    id
    name
    description
    email
  }
}
    `;
export type CreateEventAccountMutationFn = Apollo.MutationFunction<CreateEventAccountMutation, CreateEventAccountMutationVariables>;

/**
 * __useCreateEventAccountMutation__
 *
 * To run a mutation, you first call `useCreateEventAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventAccountMutation, { data, loading, error }] = useCreateEventAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEventAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventAccountMutation, CreateEventAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventAccountMutation, CreateEventAccountMutationVariables>(CreateEventAccountDocument, options);
      }
export type CreateEventAccountMutationHookResult = ReturnType<typeof useCreateEventAccountMutation>;
export type CreateEventAccountMutationResult = Apollo.MutationResult<CreateEventAccountMutation>;
export type CreateEventAccountMutationOptions = Apollo.BaseMutationOptions<CreateEventAccountMutation, CreateEventAccountMutationVariables>;